var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail24 = function SvgEmail24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12a8 8 0 1 1 16 0v2.5a1.5 1.5 0 0 1-1.5 1.5H18a1 1 0 0 1-1-1v-3a5 5 0 1 0-1.864 3.895A3.001 3.001 0 0 0 18 18h.5a3.5 3.5 0 0 0 3.5-3.5V12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10h3a1 1 0 1 0 0-2h-3a8 8 0 0 1-8-8Zm11 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
    fill: "currentColor"
  })));
};
export default SvgEmail24;